import type * as React from 'react';
import { cn } from '../lib/cn.js';

/**
 * The browser's own `<select>`, dressed as an `Input`.
 *
 * For the short, flat choices inside a form row — a channel, a filter, a field
 * of a condition — where the Radix `Select` is more machinery than the choice
 * needs, and where a phone's native picker is the better control anyway. Ten
 * screens had written this one by hand, each with its own copy of the classes.
 */
export function NativeSelect({ className, ...props }: React.ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'h-[var(--control-height)] min-w-0 rounded-control border border-border-strong',
        'bg-surface px-2.5 text-body text-ink transition-colors duration-[var(--duration-exit)] ease-standard',
        'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-muted',
        'aria-invalid:border-danger',
        className,
      )}
      {...props}
    />
  );
}
